module.exports = __webpack_public_path__ + "img/JS.d43178dc.jpg";